import urlConfig from '../urlConfig';

async function getGoogleRSParams() {
  const {
    o, kw, terms, kwSource: paramKwSource, maxSKSResults,
  } = this.pageParams;
  const { generator, signals, kwSource: dataKwSource } = this.dataset;
  const kwSource = paramKwSource || dataKwSource;

  if (!o) {
    throw new Error('Missing ocode');
  }

  const dabuUrl = new URL(`${this.dabuUrl}/api/v2/ta/google`);
  dabuUrl.searchParams.set('o', o);
  dabuUrl.searchParams.set('sessionId', this.pvId);
  dabuUrl.searchParams.set('surl', this.sourceUrl);
  if (generator) {
    dabuUrl.searchParams.set('generator', generator);
  }
  if (signals) {
    dabuUrl.searchParams.set('signals', signals);
  }
  if (kw) {
    dabuUrl.searchParams.set(`${kwSource === 'sibk' ? 'title' : 'kw'}`, kw);
  }

  if (kwSource) {
    dabuUrl.searchParams.set('kwSource', kwSource);
  }
  if (maxSKSResults) {
    dabuUrl.searchParams.set('maxSKSResults', maxSKSResults);
  }
  // if terms are defined, no need to retrieve keywords
  // for sibk, if we want to retrieve terms base on kw, we won't pass in surl
  if (terms || (kwSource === 'sibk' && kw)) {
    dabuUrl.searchParams.delete('surl');
  }

  try {
    // there should only be one item in this array
    const dabuRes = await this.callDabu(dabuUrl.toString());
    this.logger.debug('GRS making a call to Dabu', dabuRes);

    this.mountGoogleRS(dabuRes);
  } catch (err) {
    // TODO: log error/failure
    this.logger.error('Error making dabu call or mounting Google Related Search', err);
  }
}

// MOUNTING METHODS

function mountGoogleRS(dabuRes) {
  const { pubId, styleId, googleChannel } = dabuRes;
  const {
    rch,
    ad,
    an,
    ag,
    o,
    kw,
    terms,
    cid,
    gclid = '',
    gStyleId,
    fbclid = '',
    utm_campaign: uCampaign,
    clickID = '',
    taboola_click_id: taboolaClickId,
    site_id: taboolaSiteId,
    sclid,
    rc_click_id: rcClickId,
    cmt,
    ckid,
  } = this.pageParams;
  const { dabuLp, gStyleId: dataGStyleId } = this.dataset;

  const finalStyleId = gStyleId || dataGStyleId || styleId;

  const placementIds = Object.keys(this.adPlacements);

  if (!placementIds || !pubId || !finalStyleId) {
    throw new Error('Missing placementId, pubId, and / or styleId');
  }

  this.adContext.adType = 'grs';
  this.adContext.pubId = pubId;
  this.adContext.styleId = finalStyleId;
  this.adContext.abTestGChannel = googleChannel;
  this.logger.debug('GRS Getting pubId and styleId by ocode', pubId, styleId);

  const adsenseScript = this.doc.createElement('script');
  adsenseScript.src = 'https://www.google.com/adsense/domains/caf.js';
  adsenseScript.defer = 'defer';

  this.doc.head.appendChild(adsenseScript);

  const baseURL = dabuLp || `${this.win.location.protocol}//${this.win.location.hostname}`;
  const rsPageBaseUrl = new URL(baseURL);
  const config = urlConfig[rsPageBaseUrl.hostname] || urlConfig.default;

  rsPageBaseUrl.pathname = config.pathname;

  if (ad) {
    rsPageBaseUrl.searchParams.set('ad', ad);
  }
  if (an) {
    rsPageBaseUrl.searchParams.set('an', an);
  }
  if (ag) {
    rsPageBaseUrl.searchParams.set('ag', ag);
  }
  if (o) {
    rsPageBaseUrl.searchParams.set('o', o);
  }
  if (rch) {
    rsPageBaseUrl.searchParams.set(
      'rch',
      this.appendABTestChannel(rch, this.adContext.abTestGChannel),
    );
  }
  if (this.ueId) {
    rsPageBaseUrl.searchParams.set('ueid', this.ueId);
  }
  if (this.pvId) {
    rsPageBaseUrl.searchParams.set('pvid', this.pvId);
  }
  if (uCampaign) {
    rsPageBaseUrl.searchParams.set('utm_campaign', uCampaign);
  }
  if (gclid) {
    rsPageBaseUrl.searchParams.set('gclid', gclid);
  }
  // click ID for taboola/outbrain, not to be mistaken with the campaign ID
  if (cid) {
    rsPageBaseUrl.searchParams.set('cid', cid);
  }
  if (fbclid) {
    rsPageBaseUrl.searchParams.set('fbclid', fbclid);
  }
  if (clickID) {
    rsPageBaseUrl.searchParams.set('clickID', clickID);
  }
  rsPageBaseUrl.searchParams.set('qo', 'contentGoogleRelatedSearch');
  if (taboolaClickId) {
    rsPageBaseUrl.searchParams.set('taboola_click_id', taboolaClickId);
  }

  if (taboolaSiteId) {
    rsPageBaseUrl.searchParams.set('site_id', taboolaSiteId);
  }
  if (sclid) {
    rsPageBaseUrl.searchParams.set('sclid', sclid);
  }
  if (rcClickId) {
    rsPageBaseUrl.searchParams.set('rc_click_id', rcClickId);
  }
  if (cmt) {
    rsPageBaseUrl.searchParams.set('cmt', cmt);
  }
  if (ckid) {
    rsPageBaseUrl.searchParams.set('ckid', ckid);
  }

  const grsPageOptions = {
    pubId,
    styleId: finalStyleId,
    relatedSearchTargeting: 'content',
    resultsPageBaseUrl: rsPageBaseUrl.toString(),
    resultsPageQueryParam: 'q',
    channel: this.appendABTestChannel(rch, this.adContext.abTestGChannel),
    kw,
    terms: terms || dabuRes.sibkTerms,
  };

  this.firePageViewPixel();

  const clicktrackUrl = this.getGoogleAdsClickTrackUrl();

  let rsBlocks = '';
  placementIds.forEach((id, idx) => {
    const relatedSearches = 5;
    rsBlocks += `const rsBlock${idx + 1} = {
                    container : '${id}',
                    type: 'relatedsearch',
                    number: 5,
                    relatedSearches: ${relatedSearches},
                    ${clicktrackUrl ? `clicktrackUrl: '${clicktrackUrl}',` : ''}
                    adLoadedCallback: function (containerId, adsLoaded, param, callbackOptions) {
                      const logger = window.amgAds.grs.adPlacements.${id}.logger;
                      logger.debug("GRS adsLoaded", adsLoaded);
                      logger.debug('callbackOptions', callbackOptions);
                      const parentCallback = window.amgAds.adsLoadedCallback || function() {};

                      if(adsLoaded) {
                        // google's products don't know about each other
                        // and they will create iframes for different prodcts with the same ids
                        // this is a workaround to prevent this clobering from taking place
                        const selector = '#' + containerId + ' > iframe';
                        const iframes = document.querySelectorAll(selector);
                        const ro = new ResizeObserver(function (entries, observer) {
                          entries.forEach(function(entry){
                            if (entry.target.clientHeight > 1) {
                              logger.debug('Renaming: ', containerId + ' > ' + entry.target.id);
                              entry.target.id += 'rendered'
                            };
                          });
                        });
                        Array.prototype.forEach.call(iframes, function (iframe) {
                          ro.observe(iframe)
                        });

                        const grsPlacementsIds = Object.keys(window.amgAds.grs.adPlacements);
                        const isFirstBlock = grsPlacementsIds.length && grsPlacementsIds[0] === '${id}';

                        // Ad-InView Event
                        const grsElement = document.getElementById('${id}');

                        const IntersectionObserver = window.IntersectionObserver;

                        const grsInViewObserver = new IntersectionObserver(function (entries) {
                          if (entries[0].intersectionRatio > 0) {
                            const gaPayload = logger.getInViewPayload(isFirstBlock);
                            logger.logEvent(gaPayload);
                            grsInViewObserver.unobserve(grsElement);
                          }
                        });
                        grsInViewObserver.observe(grsElement);

                        // ContentRendered Event triggers only once
                        if(isFirstBlock) {
                          const termPositions = callbackOptions ? callbackOptions.termPositions : '';
                          const dabuRes = ${JSON.stringify(dabuRes)};
                          const numLinks = termPositions ? Object.keys(termPositions).length : 0;
                          const adResultsDisplayedTop = numLinks <= ${relatedSearches} ? numLinks : ${relatedSearches};
                          const adResultsDisplayedBottom = numLinks > ${relatedSearches} ? numLinks - ${relatedSearches} : undefined;
                          const loggerPayload = {
                                          eventType: 'ContentRendered',
                                          numLinks: numLinks,
                                          termPositions: JSON.stringify(termPositions),
                                          adResultsDisplayedTop,
                                          adResultsDisplayedBottom};
                          Object.assign(loggerPayload, dabuRes);
                          
                          const payload = logger.getContentRenderedPayload('grs', loggerPayload);
                          logger.logEvent(payload);
                        }
                        parentCallback(null, containerId);
                      } else {
                        parentCallback(new Error('Ad not loaded.'), containerId);
                      }
                    }
                  };

                  rsBlocks.push(rsBlock${idx + 1});
                  `;
  });

  const grsScript = document.createElement('script');
  grsScript.setAttribute('type', 'text/javascript');
  grsScript.defer = 'defer';
  grsScript.innerHTML = `
    const grsPageOptions=${JSON.stringify(grsPageOptions)};
    const rsBlocks=[];

    ${rsBlocks}

    new google.ads.domains.Caf(grsPageOptions, rsBlocks);`;

  adsenseScript.addEventListener('load', () => {
    this.doc.body.appendChild(grsScript);
    this.logger.debug('Mounting Google Related Search to dom nodes', this.dataset.dabuPlacementId);
  });
}

export { getGoogleRSParams, mountGoogleRS };
